import {urls as jsClientURLs} from '@apps-common/js-client';
import request, {setAppHeader} from '@apps-common/js-client/api/request';
import qs from 'qs';
import urls from './urls.ts';

// this injects the value as the base url for all requests
jsClientURLs.setBase(urls.base);
request.defaults.baseURL = urls.base;

setAppHeader('acorns', [
  urls.destinations,
  urls.order,
  urls.pdaAdmin,
  urls.subscriptions,
]);

request.defaults.paramsSerializer = {
  serialize: params =>
    qs.stringify(params, {
      skipNulls: true,
      arrayFormat: 'repeat',
      allowEmptyArrays: false,
    }),
};

export {request};
